// src/firebase.js
import { initializeApp, getApps, getApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth"; // 1. මෙය ඉම්පෝට් කරගන්න

const firebaseConfig = {
  apiKey: "AIzaSyCyBMde691ZsiGZ0UNlwhXem3uJkUy70as",
  authDomain: "photo-gallery-8b4f9.firebaseapp.com",
  projectId: "photo-gallery-8b4f9",
  messagingSenderId: "13806142699",
  appId: "1:13806142699:web:244fc180fc067e85602aae",
};

const app = getApps().length ? getApp() : initializeApp(firebaseConfig);


export const db = getFirestore(app);
export const auth = getAuth(app); 